import { useMemo } from 'react';
import dict from '../i18n/cookieBanner.json';
import { createT } from '../i18n/createT';

/**
 * Traducteur du bandeau de consentement.
 *
 * Il a son propre dictionnaire, minuscule, plutôt qu'une entrée dans
 * `app.json` : le bandeau est le SEUL composant monté sur toutes les
 * pages publiques, y compris avant que quoi que ce soit d'autre ne soit
 * chargé. Lui faire tirer un dictionnaire de plusieurs milliers de lignes
 * pour cinq chaînes serait payer le poids de l'app entière pour la
 * première frame de la première visite.
 *
 * Même repli que partout : langue demandée → français (cf. `createT`).
 */
export function useCookieBannerT(language) {
  return useMemo(() => createT(dict, language), [language]);
}

export default useCookieBannerT;
